export default {
    SET_CONTRACT_FORM: 'setContractForm',
    CLEAR_CONTRACT_FORM: 'clearContractForm',
    SET_THRESHOLD: 'setThreshold',
}
